var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiraffeSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 635.9 1164.7",
    style: {
      enableBackground: "new 0 0 635.9 1164.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DF8026;}\n\t.st1{fill:#FFCC80;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#FFDCBD;}\n\t.st4{fill:#BF2626;}\n\t.st5{fill:none;stroke:#BF2626;stroke-width:5;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000126318093147777164610000012587247500211085477_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_layer"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 95.4,
    cy: 192.1,
    rx: 95.4,
    ry: 30.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9217 -0.388 0.388 0.9217 -15.6826 224.1213)",
    className: "st0",
    cx: 547.2,
    cy: 150.9,
    rx: 95.4,
    ry: 30.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M564.4,239.1v242.2c-0.1,71.5-38.1,137.7-100,173.6c-1.3,15.3-2.5,30.5-3.4,45.6 c-2.7,43.2-4.2,85.6-4.3,127.3c0.5,8.9,1,17.7,1.4,26.5c0.5,9.2,1,18.4,1.5,27.6c2,37.6,4,75.3,6.1,112.9l7.2,134.2l-4.2,35.6 h-200c-4.7-12-9.1-24.7-13-38c-11.4-38.4-18-78.1-19.8-118.2c-0.8-18-0.6-35.3,0.2-51.6c0.6-12,1.6-23.4,2.9-34.3 c3-34,6.1-68,9.2-102.1c0.7-7.9,1.5-15.8,2.2-23.7c2.3-25,4.7-49.9,7.1-74.9c0.1-1.5,0.3-3.1,0.4-4.6c1.6-17.1,3.3-34.1,5-51.2 C189,634.6,140.8,561.8,140.8,481.3V239.1c0-71.5,58-129.5,129.5-129.5h164.6C506.4,109.5,564.4,167.5,564.4,239.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M291.5,283.9c-18.2-21.5-50.4-24.1-71.9-5.9c-15.5,13.2-21.7,34.3-15.8,53.8c-18.2-21.5-15.6-53.7,5.9-71.9 s53.7-15.6,71.9,5.9C286.1,271.1,289.5,277.3,291.5,283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M296,297.2c0,29.9-24,54.1-53.6,54.1c-15.8,0-30.7-7-40.8-19.1c-1.6-5.1-2.3-10.5-2.3-15.8 c0-29.9,24-54.1,53.6-54.1c15.8,0,30.7,7,40.8,19.1C295.2,286.5,296,291.9,296,297.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M421.6,283.9c18.2-21.5,50.4-24.1,71.9-5.9c15.5,13.2,21.7,34.3,15.8,53.8c18.2-21.5,15.6-53.7-5.9-71.9 c-21.5-18.2-53.7-15.6-71.9,5.9C427,271.1,423.6,277.3,421.6,283.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.7,298.1c0,30.5,23.7,55.2,52.9,55.2c15.7-0.1,30.5-7.2,40.3-19.5c1.5-5.2,2.3-10.7,2.3-16.1 c0-30.5-23.7-55.2-52.9-55.2c-15.7,0.1-30.5,7.2-40.3,19.5C418.5,287.2,417.7,292.6,417.7,298.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M509.4,543.8v57.5c-36.6,49.6-88.3,80.6-145.6,80.6h-22.3c-45.4,0-87.3-19.4-120.9-52.1v-86 c0-82.4,51.9-149.2,116-149.2h56.9C457.5,394.6,509.4,461.4,509.4,543.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 306.5,
    cy: 454.8,
    r: 5.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M423,454.8c0,3-2.4,5.4-5.4,5.4c-3,0-5.4-2.4-5.4-5.4s2.4-5.4,5.4-5.4c0,0,0,0,0,0 C420.6,449.3,423,451.8,423,454.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M272.5,596.3c26,12.6,43.6,22.5,59.7,26.3c16.8,3.9,35.8,3.7,54.7,2.5c11.7-0.7,30.8-2.1,50.2-14.4 c6.7-4.3,12.8-9.4,18.2-15.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.9,
    y: 49.7,
    className: "st1",
    width: 31.6,
    height: 85.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.1,
    y: 49.7,
    className: "st1",
    width: 31.6,
    height: 85.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 204.4524 308.525)",
    className: "st0",
    cx: 283.5,
    cy: 34.1,
    rx: 34.1,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9975 -7.097519e-02 7.097519e-02 0.9975 -1.3038 31.4489)",
    className: "st0",
    cx: 441.9,
    cy: 34.1,
    rx: 34.1,
    ry: 34.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.1,151.1c6.7,21.8,6.8,28.5,10,29.1c8,1.6,18.4-36.8,28.4-35.4c8.2,1.1,8.9,27.9,16.1,28.4 c7.4,0.5,12.5-27.3,19.2-26.7c7.1,0.6,9.2,32.1,12.6,31.9c3.9-0.2,0.5-41.8,10.9-44.9c9.3-2.8,26.1,32.7,28.5,31.4 c1.8-1-12.4-19.2-7.6-37.5c4.6-17.6,23.2-21.3,21.5-30.8c-1.6-8.8-19.3-15.8-34.4-14.2c-17.5,1.8-21.9,13.9-33.7,11.3 c-11.1-2.4-11.6-14-24.5-19.6c-4-1.7-7.4-2-29.7,1.2c-20.8,3-38.1,6.1-59.3,13c-13.1,4.3-16,6.2-17.8,9.5 c-6.6,12.1,5.6,36.3,20.2,39.2c12.3,2.4,20.6-11.5,29.7-7.1C302.6,131,304.6,133.2,310.1,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M329.5,890.2c0,38.9-31.6,70.5-70.5,70.5c-7.7,0-15.4-1.3-22.7-3.8c0.6-12,1.6-23.4,2.9-34.3 c3-34,6.1-68,9.2-102.1c38.5-5.8,74.4,20.7,80.3,59.2C329.3,883.2,329.5,886.7,329.5,890.2L329.5,890.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456.8,827.8c0.5,8.9,1,17.7,1.4,26.5c-42.7,9.3-84.8-17.8-94-60.5c-9.3-42.7,17.8-84.8,60.5-94 c12-2.6,24.5-2.4,36.4,0.7C458.4,743.6,456.9,786.1,456.8,827.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.8,994.9c-30.6,11.7-65-3.6-76.7-34.2s3.6-65,34.2-76.7c11.6-4.5,24.4-5.1,36.4-2 C461.8,919.6,463.8,957.2,465.8,994.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M304.9,760.5c0,21.7-17.6,39.3-39.4,39.3c-5.1,0-10.2-1-14.9-2.9c2.3-25,4.7-49.9,7.1-74.9 c21.3-4.3,42,9.5,46.4,30.8C304.7,755.2,304.9,757.8,304.9,760.5L304.9,760.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M419.8,1101.5c0,22.5-6.5,44.4-18.9,63.2h-132c-4.7-12-9.1-24.7-13-38c-11.4-38.4-18-78.1-19.8-118.2 c51.3-37.7,123.5-26.7,161.2,24.6C412,1053,419.8,1076.9,419.8,1101.5L419.8,1101.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 357.7,
    cy: 253.9,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 392.2,
    cy: 217.5,
    r: 13
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 320.5,
    cy: 210,
    r: 24.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 327.9,
    cy: 300.2,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 333.2,
    cy: 356.8,
    r: 13.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 377.8,
    cy: 319.6,
    r: 27.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiraffeSvg);
export default __webpack_public_path__ + "static/media/GiraffeSVG.93897f5424d4b7864ac7c06e08a2663a.svg";
export { ForwardRef as ReactComponent };